module.exports = __webpack_public_path__ + "img/zs.4edd20cf.png";